module.exports = __webpack_public_path__ + "img/MEDIA012.f6ad3fb7.jpg";